import React from 'react';
import { ModalContainer } from './style';

export type ModalProps = {
  open: boolean;
  children: JSX.Element;
  opacity?: string;
  top?: string;
  mobile?: boolean;
  verticalCenterd?: boolean;
};

const Modal: React.FC<ModalProps> = ({ open, children, opacity, top, mobile, verticalCenterd }) => {

  return (
    <>
      {open?
        <ModalContainer
          opacity={opacity}
          top={top}
          mobile={mobile}
          verticalCenterd={verticalCenterd}
        >
          {children}
        </ModalContainer>
        : null
      }
    </>
  )
}

export default Modal;
